import { render } from "./VideoThumb.vue?vue&type=template&id=27750fc9&scoped=true"
import script from "./VideoThumb.vue?vue&type=script&lang=js"
export * from "./VideoThumb.vue?vue&type=script&lang=js"

import "./VideoThumb.vue?vue&type=style&index=0&id=27750fc9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27750fc9"]])

export default __exports__